import React, { useRef } from "react";
import { Provider } from "react-redux";
import widenSearchStore from "../../redux/store";
import { WidenModal } from "./WidenModal";
import { assetConstructor } from "../../utils/assetConstructor";
export const WidenLibrary = ({
  allowedTypes,
  onClose
}) => {
  const selectedAssets = useRef([]);
  const handleSelectAsset = item => {
    const asset = assetConstructor(item);
    acumulateAsset(asset);
    onClose(selectedAssets.current);
  };
  const acumulateAsset = asset => {
    if (isAssetAlreadyAcumulate(asset)) return;
    selectedAssets.current = [...selectedAssets.current, asset];
  };
  const isAssetAlreadyAcumulate = asset => selectedAssets.current.some(({
    id
  }) => id === asset.id);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Provider, {
    store: widenSearchStore
  }, /*#__PURE__*/React.createElement(WidenModal, {
    onSelect: handleSelectAsset,
    filter: allowedTypes,
    onClose: onClose
  })));
};